import _classCallCheck from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _pt from "prop-types";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import { css } from '@patternfly/react-styles';
import { DropdownContext } from './dropdownConstants';
import { KEY_CODES, KEYHANDLER_DIRECTION } from '../../helpers/constants';
import { Tooltip } from '../Tooltip';
export var InternalDropdownItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InternalDropdownItem, _React$Component);

  function InternalDropdownItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, InternalDropdownItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InternalDropdownItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "ref", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      // Detected key press on this item, notify the menu parent so that the appropriate
      // item can be focused
      if (event.keyCode === KEY_CODES.TAB) {
        return;
      }

      event.preventDefault();

      if (event.keyCode === KEY_CODES.ARROW_UP) {
        _this.props.context.keyHandler(_this.props.index, KEYHANDLER_DIRECTION.UP);
      } else if (event.keyCode === KEY_CODES.ARROW_DOWN) {
        _this.props.context.keyHandler(_this.props.index, KEYHANDLER_DIRECTION.DOWN);
      } else if (event.keyCode === KEY_CODES.ENTER && _this.ref.current && _this.ref.current.click) {
        _this.ref.current.click();
      }
    });

    return _this;
  }

  _createClass(InternalDropdownItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          context = _this$props2.context,
          index = _this$props2.index,
          isDisabled = _this$props2.isDisabled,
          role = _this$props2.role;
      context.sendRef(index, this.ref.current, isDisabled, role === 'separator');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          isHovered = _this$props.isHovered,
          context = _this$props.context,
          _onClick = _this$props.onClick,
          component = _this$props.component,
          role = _this$props.role,
          isDisabled = _this$props.isDisabled,
          index = _this$props.index,
          href = _this$props.href,
          tooltip = _this$props.tooltip,
          tooltipProps = _this$props.tooltipProps,
          additionalProps = _objectWithoutProperties(_this$props, ["className", "children", "isHovered", "context", "onClick", "component", "role", "isDisabled", "index", "href", "tooltip", "tooltipProps"]);

      var Component = component;
      var classes;

      if (Component === 'a') {
        additionalProps['aria-disabled'] = isDisabled;
        additionalProps.tabIndex = isDisabled ? -1 : additionalProps.tabIndex;
      } else if (Component === 'button') {
        additionalProps.disabled = isDisabled;
        additionalProps.type = additionalProps.type || 'button';
      }

      var renderWithTooltip = function renderWithTooltip(childNode) {
        return tooltip ? React.createElement(Tooltip, _extends({
          content: tooltip
        }, tooltipProps), childNode) : childNode;
      };

      return React.createElement(DropdownContext.Consumer, null, function (_ref) {
        var onSelect = _ref.onSelect,
            itemClass = _ref.itemClass,
            disabledClass = _ref.disabledClass,
            hoverClass = _ref.hoverClass;

        if (_this2.props.role === 'separator') {
          classes = className;
        } else {
          classes = css(isDisabled && disabledClass, isHovered && hoverClass, className);
        }

        return React.createElement("li", {
          role: role
        }, renderWithTooltip(React.createElement(Component, _extends({}, additionalProps, {
          href: href || null,
          className: css(classes, _this2.props.role !== 'separator' && itemClass),
          ref: _this2.ref,
          onKeyDown: _this2.onKeyDown,
          onClick: function onClick(event) {
            if (!isDisabled) {
              _onClick(event);

              onSelect(event);
            }
          }
        }), children)));
      });
    }
  }]);

  return InternalDropdownItem;
}(React.Component);

_defineProperty(InternalDropdownItem, "propTypes", {
  children: _pt.node,
  className: _pt.string,
  component: _pt.oneOfType([_pt.node, _pt.string]),
  role: _pt.string,
  isDisabled: _pt.bool,
  isHovered: _pt.bool,
  href: _pt.string,
  tooltip: _pt.node,
  tooltipProps: _pt.any,
  index: _pt.number,
  context: _pt.shape({
    keyHandler: _pt.func,
    sendRef: _pt.func
  }),
  onClick: _pt.func
});

_defineProperty(InternalDropdownItem, "defaultProps", {
  className: '',
  isHovered: false,
  component: 'a',
  role: 'none',
  isDisabled: false,
  href: '',
  tooltipProps: {},
  onClick: function onClick(event) {
    return undefined;
  },
  onSelect: function onSelect() {
    return undefined;
  },
  index: -1,
  context: {
    keyHandler: Function.prototype,
    sendRef: Function.prototype
  }
});